import Tabs from '@cas/components/tabs/tabs/Tabs';
import styles from './FaultLevelTabs.module.scss';
import { useCallback, useMemo } from 'react';
import { FaultLevel, FaultLevelKey, faultLevelKeys } from '@customer/store/slices/globalSlice';
import useTabs, { TabConfig } from '@cas/components/tabs/tabs/useTabs';
import { setFaultLevel } from '@customer/store/slices/healthSlice';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '@customer/store/hooks';

export function FaultLevelTabs() {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const faultLevel = useAppSelector(state => state.health.faultLevel);

  const onLevelSelected = useCallback(
    (level: FaultLevel) => dispatch(setFaultLevel(level)),
    [dispatch],
  );

  const tabConfigs: TabConfig[] = useMemo(() => {
    return faultLevelKeys.map((key: FaultLevelKey) => ({
      title: t('FaultsLevel', { level: FaultLevel[key] }),
      view: null,
    }));
  }, [t]);

  const tabIndex = Number(faultLevel) - 1; // Convert FaultLevel string to index (0-based).

  const { tabs, activeTab, onSelectTab } = useTabs({
    tabConfigs,
    defaultTab: tabIndex,
  });

  const onChangeTab = useCallback(
    (index: number) => {
      const level = FaultLevel[faultLevelKeys[index]];
      onLevelSelected(level);
      onSelectTab(index);
    },
    [onLevelSelected, onSelectTab],
  );

  return (
    <div className={styles.tabs}>
      <Tabs tabs={tabs} activeTab={activeTab} onSelectTab={onChangeTab} />
    </div>
  );
}

export default FaultLevelTabs;
